<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      height="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>{{title}}</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <!-- <el-button
                type="primary"
                @click="ModifyStatus(1)"
                v-if="OpStatus == 'Detail' && SelectData.status == 0"
                >审核</el-button
              >
              <el-button
                type="primary"
                @click="ModifyStatus(2)"
                v-if="OpStatus == 'Detail' && SelectData.status == 0"
              >
                终止</el-button
              > -->
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 编辑区域-->
          <!-- 表单区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="search-form">
              <el-form
                :model="SelectData"
                :rules="rules"
                size="small"
                label-position="right"
                status-icon
                ref="form"
              >
                <div class="formtabs">
                  <!-- <div class="formtabs-title">受伤人基本信息</div> -->
                  <div class="formtabs-content">
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="12">
                        <div class="grid-content bg-purple">
                          <el-form-item label="省-市-区" prop="provinceId">
                            <el-select
                              style="width: 10rem"
                              v-model="SelectData.provinceId"
                              placeholder="请选择省"
                              :disabled="IsReadonlyCode || provinceid != 0"
                              @change="ProvinceChange"
                              filterable
                            >
                              <el-option
                                v-for="item in ProvinceList"
                                :key="item.id"
                                :label="item.areaName"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                            <el-select
                              style="width: 10rem"
                              v-model="SelectData.cityId"
                              placeholder="请选择市"
                              :disabled="IsReadonly || provinceid != 0"
                              @change="CityChange"
                              filterable
                            >
                              <el-option
                                v-for="item in CityList"
                                :key="item.id"
                                :label="item.areaName"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                            <el-select
                              style="width: 10rem"
                              v-model="SelectData.regionId"
                              placeholder="请选择区"
                              :disabled="IsReadonly"
                              filterable
                            >
                              <el-option
                                v-for="item in RegionList"
                                :key="item.id"
                                :label="item.areaName"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="所属单位" prop="injuryUnitId">
                            <LoadMoreSelector
                              v-model="SelectData.injuryUnitId"
                              placeholder="所属单位"
                              url="/api/app/injuryUnit/list"
                              :filterable="true"
                              :collapse-tags="false"
                              :collapse-tags-tooltip="false"
                              :multiple="false"
                              :remote="true"
                              :formater="formater"
                              :disabled="IsReadonlyCode"
                              :ids="SelectData.injuryUnitId"
                              :allowcreate="true"
                              :defaultfirstoption="true"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="所属行业" prop="injuryTypeId">
                            <LoadMoreSelector
                              v-model="SelectData.injuryTypeId"
                              placeholder="所属行业"
                              url="/api/app/injuryType/list"
                              :filterable="true"
                              :collapse-tags="false"
                              :collapse-tags-tooltip="false"
                              :multiple="false"
                              :remote="true"
                              :formater="formater"
                              :disabled="IsReadonly"
                              :ids="SelectData.injuryTypeId"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="姓名" prop="injuryUserName">
                            <el-input
                              id="injuryUserName"
                              v-model="SelectData.injuryUserName"
                              clearable
                              :disabled="IsReadonlyCode"
                              required="true"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="年龄" prop="injuryUserAge">
                            <el-input-number
                              v-model="SelectData.injuryUserAge"
                              :min="0"
                              :controls="false"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="性别" prop="sex">
                            <el-select
                              v-model="SelectData.sex"
                              placeholder="性别"
                              :disabled="IsReadonly"
                            >
                              <el-option
                                v-for="item in SexList"
                                :key="item.val"
                                :label="item.name"
                                :value="item.val"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div class="formtabs">
                  <!-- <div class="formtabs-title">受伤情况</div> -->
                  <div class="formtabs-content">
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="受伤时间" prop="injuryTime">
                            <el-date-picker
                              v-model="SelectData.injuryTime"
                              type="datetime"
                              :disabled="IsReadonlyCode"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="是否死亡" prop="isDeath">
                            <el-select
                              v-model="SelectData.isDeath"
                              placeholder="是否死亡"
                              :disabled="IsReadonly"
                            >
                              <el-option
                                v-for="item in IsDeathList"
                                :key="item.val"
                                :label="item.name"
                                :value="item.val"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="受伤部位" prop="injurySiteId">
                            <LoadMoreSelector
                              v-model="SelectData.injurySiteId"
                              placeholder="受伤部位"
                              url="/api/app/injurySite/list"
                              :filterable="true"
                              :collapse-tags="false"
                              :collapse-tags-tooltip="false"
                              :multiple="false"
                              :remote="true"
                              :formater="formater"
                              :disabled="IsReadonly"
                              :ids="SelectData.injurySiteId"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="伤害类型" prop="injuryPartId">
                            <LoadMoreSelector
                              v-model="SelectData.injuryPartId"
                              placeholder="伤害类型"
                              url="/api/app/injuryPart/list"
                              :filterable="true"
                              :collapse-tags="false"
                              :collapse-tags-tooltip="false"
                              :multiple="false"
                              :remote="true"
                              :formater="formater"
                              :disabled="IsReadonly"
                              :ids="SelectData.injuryPartId"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item
                            label="职业病"
                            prop="occupationDiseaseId"
                          >
                            <LoadMoreSelector
                              v-model="SelectData.occupationDiseaseId"
                              placeholder="职业病"
                              url="/api/app/OccupationDisease/list"
                              :filterable="true"
                              :collapse-tags="false"
                              :collapse-tags-tooltip="false"
                              :multiple="false"
                              :remote="true"
                              :formater="formater"
                              :disabled="IsReadonly"
                              :ids="SelectData.occupationDiseaseId"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="24">
                        <div class="grid-content bg-purple">
                          <el-form-item label="受伤时间以及部位描述">
                            <el-input
                              id="injuryDescribe"
                              type="textarea"
                              v-model="SelectData.injuryDescribe"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="24">
                        <div class="grid-content bg-purple">
                          <el-form-item label="工伤地点">
                            <el-input
                              id="injuryAddress"
                              type="textarea"
                              v-model="SelectData.injuryAddress"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>

                <div class="formtabs">
                  <!-- <div class="formtabs-title">其他信息</div> -->
                  <div class="formtabs-content">
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="入职时间" prop="entryDate">
                            <el-date-picker
                              v-model="SelectData.entryDate"
                              type="datetime"
                              :disabled="IsReadonly"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="岗位">
                            <el-input
                              v-model="SelectData.post"
                              placeholder="岗位"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="文化程度">
                            <el-input
                              v-model="SelectData.cultureLevel"
                              placeholder="文化程度"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>

                <div class="formtabs">
                  <!-- <div class="formtabs-title">认定情况</div> -->
                  <div class="formtabs-content">
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="申请时间" prop="applyTime">
                            <el-date-picker
                              v-model="SelectData.applyTime"
                              type="datetime"
                              :disabled="IsReadonly"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="申请人" prop="applyUser">
                            <el-input
                              id="applyUser"
                              v-model="SelectData.applyUser"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="受理时间" prop="acceptanceTime">
                            <el-date-picker
                              v-model="SelectData.acceptanceTime"
                              type="datetime"
                              :disabled="IsReadonly"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="grid-content bg-purple">
                          <el-form-item label="经办人" prop="handler">
                            <el-input
                              id="handler"
                              v-model="SelectData.handler"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="8">
                        <div class="grid-content bg-purple">
                          <el-form-item
                            label="符合条款"
                            prop="complianceClause"
                          >
                            <el-input
                              id="complianceClause"
                              v-model="SelectData.complianceClause"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="grid-content bg-purple">
                          <el-form-item
                            label="认定决定"
                            prop="applyDetermination"
                          >
                            <el-input
                              id="applyDetermination"
                              v-model="SelectData.applyDetermination"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="grid-content bg-purple">
                          <el-form-item
                            label="认定书编号"
                            prop="applyDeterminationNumber"
                          >
                            <el-input
                              id="applyDeterminationNumber"
                              v-model="SelectData.applyDeterminationNumber"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="8">
                        <div class="grid-content bg-purple">
                          <el-form-item
                            label="审签时间"
                            prop="reviewSignatureTime"
                          >
                            <el-date-picker
                              v-model="SelectData.reviewSignatureTime"
                              type="datetime"
                              :disabled="IsReadonly"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="grid-content bg-purple">
                          <el-form-item label="处理批次" prop="processBatch">
                            <el-input
                              id="processBatch"
                              v-model="SelectData.processBatch"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20" class="row-bg">
                      <el-col :span="24">
                        <div class="grid-content bg-purple">
                          <el-form-item label="备注">
                            <el-input
                              id="remarks"
                              type="textarea"
                              v-model="SelectData.remarks"
                              clearable
                              :disabled="IsReadonly"
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import {
  SelectInjuryAffirmBillById,
  ModifyInjuryAffirmBill,
  AddInjuryAffirmBill,
} from "@api/ApiInjuryAffirmBill";

import { ProvinceList } from "@/assets/apiData/Province";

import { GetDataInjuryTypeList } from "@api/ApiInjuryType";

import { GetDataInjurySiteList } from "@api/ApiInjurySite";

import { GetDataOccupationDiseaseList } from "@api/ApiOccupationDisease";

import { GetDataInjuryUnitList } from "@api/ApiInjuryUnit";

import { GetDatainjuryPartList } from "@api/ApiInjuryPart";

import LoadMoreSelector from "@comp/SelectorWithLoadMore/index";

export default {
  name: "InjuryAffirmBillEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "工伤认定单",
    },
    billtype: {
      type: String,
      default: "铁安通",
    },
    provinceid: {
      type: Number,
      default: 0,
    },
    cityid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      SelectData: {
        sex: 0,
        isDeath: false,
      },
      IsReadonly: false,
      IsReadonlyCode: true,
      IsShowConfirm: true,
      IndustrialUnitList: [],
      InjuryTypeList: [],
      InjurySiteList: [],
      OccupationDiseaseList: [],
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        pageSize: 1000,
      },
      IsDeathList: [
        { name: "是", val: true },
        { name: "否", val: false },
      ],
      SexList: [
        { name: "男", val: 0 },
        { name: "女", val: 1 },
      ],
      OpStatusList: [
        { id: 0, txt: "未审批" },
        { id: 1, txt: "已审核" },
        { id: 2, txt: "已终止" },
      ],
      InjuryPartList: [],
      ProvinceList: [],
      CityList: [],
      RegionList: [],
      OpStatus: "Detail",
      rules: {
        injuryUserName: [
          { required: true, message: "请输入姓名", trigger: "change" },
        ],
        injuryUnitId: [
          { required: true, message: "请选择所属单位", trigger: "change" },
        ],
        injuryTime: [
          { required: true, message: "请选择受伤时间", trigger: "change" },
        ],
        provinceId: [
          { required: true, message: "请选择省", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      id: "",
    });
  },
  mounted() {},
  updated() {
    if (this.$refs["form"]) {
      this.$refs["form"].clearValidate();
    }
  },
  components: {
    LoadMoreSelector,
  },
  methods: {
    // 下拉框格式化数据
    formater(data) {
      return (
        data &&
        data.map((itm) => ({
          ...itm,
          key: itm.id,
          value: itm.id,
          label: itm.name,
        }))
      );
    },
    ProvinceChange: function () {
      const _this = this;
      _this.SelectData.cityId = "";
      _this.SelectData.regionId = "";
      _this.ProvinceList.map((x) => {
        if (x.id == _this.SelectData.provinceId) {
          _this.CityList = JSON.parse(
            JSON.stringify(x.children.filter((o) => o.level == 3))
          );
          _this.CityList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    CityChange() {
      const _this = this;
      _this.SelectData.regionId = "";
      _this.ProvinceList.map((x) => {
        if (x.id == _this.SelectData.provinceId) {
          var cityId = _this.SelectData.cityId;
          var parentCode = _this.getCodeById(cityId);
          _this.RegionList = JSON.parse(
            JSON.stringify(
              x.children.filter(
                (o) => o.level == 4 && o.parentCode == parentCode
              )
            )
          );
          _this.RegionList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    getCodeById(id) {
      var code = "";
      var _this = this;
      _this.ProvinceList.map((x) => {
        if (x.id == _this.SelectData.provinceId) {
          x.children.forEach((o) => {
            if (o.id == id) {
              code = o.code;
              return;
            }
          });
        }
      });
      return code;
    },
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type) {
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;
      _this.IsReadonlyCode = true;

      // _this.loadData_IndustrialUnit();
      // _this.loadData_IndustrialPart();
      // _this.loadData_InjuryTypeList();
      // _this.loadData_InjurySite();
      // _this.loadData_OccupationDisease();

      if (type == "Add") {
        _this.IsReadonlyCode = false;
        _this.SelectData = {
          sex: 0,
          isDeath: false,
          provinceId: "",
          cityId: "",
        };
        if(this.provinceid != 0) {
          _this.SelectData.provinceId = this.provinceid;
          _this.ProvinceChange();
        }
        if(this.cityid != 0) {
          _this.SelectData.cityId = this.cityid
          _this.CityChange();
        }
        return;
      } else if (type == "Detail") {
        _this.IsReadonly = true;
        _this.IsShowConfirm = false;
      }
      SelectInjuryAffirmBillById(id).then(function (data) {
        let fieldList = ["provinceId","cityId","regionId","injuryUnitId","injuryPartId","injuryTypeId","injurySiteId","occupationDiseaseId"];
        for(let i in data) {
          if(fieldList.includes(i) && data[i] == 0) {
            delete data[i]
          }
        }
        _this.SelectData = data;
        _this.edit_loadProvince();
      });
    },
    edit_loadProvince() {
      var _this = this;

      _this.ProvinceList.map((x) => {
        if (x.id == _this.SelectData.provinceId) {
          _this.CityList = JSON.parse(
            JSON.stringify(x.children.filter((o) => o.level == 3))
          );
          _this.CityList.unshift({
            areaName: "-请选择-",
            id: "",
          });

          var cityId = _this.SelectData.cityId;
          var parentCode = _this.getCodeById(cityId);
          _this.RegionList = JSON.parse(
            JSON.stringify(
              x.children.filter(
                (o) => o.level == 4 && o.parentCode == parentCode
              )
            )
          );
          _this.RegionList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    /**
     * 获取工伤事故类型
     */
    loadData_IndustrialPart() {
      const _this = this;
      GetDatainjuryPartList(_this.PageQuery).then(function (data) {
        _this.InjuryPartList = data.entities;
      });
    },
    /**
     * 获取工伤单位
     */
    loadData_IndustrialUnit() {
      const _this = this;
      GetDataInjuryUnitList(_this.PageQuery).then(function (data) {
        _this.IndustrialUnitList = data.entities;
      });
    },
    /**
     *获取所属行业
     */
    loadData_InjuryTypeList() {
      const _this = this;
      GetDataInjuryTypeList(_this.PageQuery).then(function (data) {
        _this.InjuryTypeList = data.entities;
      });
    },
    /**
     * 获取受伤部位
     */
    loadData_InjurySite() {
      const _this = this;
      GetDataInjurySiteList(_this.PageQuery).then(function (data) {
        _this.InjurySiteList = data.entities;
      });
    },
    /**
     * 获取职业病
     */
    loadData_OccupationDisease() {
      const _this = this;
      GetDataOccupationDiseaseList(_this.PageQuery).then(function (data) {
        _this.OccupationDiseaseList = data.entities;
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      var _this = this;

      // if (!_this.validate()) return;
      let savedata = JSON.parse(JSON.stringify(_this.SelectData));
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!savedata.cityId || savedata.cityId == "") {
            _this.$message.error("请选择市!");
            return;
          }
          if (!savedata.regionId || savedata.regionId == "") {
            savedata.regionId = 0;
          }
          if(typeof savedata.injuryUnitId == "string") {
            // 新增工伤单位
            savedata.injuryUnitName = savedata.injuryUnitId
            savedata.injuryUnitId = 0;
          }
          let loading = this.$loading({
            lock: true,
            text: "正在提交，请稍后",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          if (_this.OpStatus == "Add") {
            savedata.status = 0;
            savedata.type = _this.billtype;
            AddInjuryAffirmBill(savedata)
              .then(function (data) {
                loading.close();
                _this.$message.success("新增成功!");
                _this.$emit("handle-confirm");
              })
              .catch((err) => {
                loading.close();
                _this.$message.error(err.message);
              });
          } else if (_this.OpStatus == "Modify") {
            ModifyInjuryAffirmBill(savedata).then(function (data) {
              loading.close();
              _this.$message.success("编辑成功!");
              _this.$emit("handle-confirm");
            }).catch((err) => {
              loading.close();
              _this.$message.error(err.message);
            });
          }
        }
      });
    },
    validate() {
      if (
        !this.SelectData.injuryUserName ||
        this.SelectData.injuryUserName == ""
      ) {
        this.$message.error("受伤人姓名是必须的!");
        return false;
      }
      if (!this.SelectData.injuryUnitId || this.SelectData.injuryUnitId == "") {
        this.$message.error("请选择所属单位!");
        return false;
      }
      if (!this.SelectData.injuryTypeId || this.SelectData.injuryTypeId == "") {
        this.$message.error("请选择所属行业!");
        return false;
      }
      if (!this.SelectData.injurySiteId || this.SelectData.injurySiteId == "") {
        this.$message.error("请选择受伤部位!");
        return false;
      }
      if (
        !this.SelectData.occupationDiseaseId ||
        this.SelectData.occupationDiseaseId == ""
      ) {
        this.$message.error("请选择职业病!");
        return false;
      }
      if (!this.SelectData.provinceId || this.SelectData.provinceId == "") {
        this.$message.error("请选择省!");
        return false;
      }
      if (!this.SelectData.cityId || this.SelectData.cityId == "") {
        this.$message.error("请选择市!");
        return false;
      }
      if (!this.SelectData.regionId || this.SelectData.regionId == "") {
        this.$message.error("请选择区!");
        return false;
      }
      if (!this.SelectData.injuryPartId || this.SelectData.injuryPartId == "") {
        this.$message.error("请选择工伤事故类型!");
        return false;
      }
      return true;
    },
    ModifyStatus(status) {
      const _this = this;
      if (_this.SelectData.status != 0) {
        _this.$message.error("该数据已审批");
        return;
      }
      _this.SelectData.status = status;
      ModifyInjuryAffirmBill(_this.SelectData).then(function (data) {
        _this.$message.success("状态更新成功!");
        _this.$emit("handle-confirm");
      });
    },
    getNowFormatDate: function () {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        date.getHours() +
        seperator2 +
        date.getMinutes() +
        seperator2 +
        date.getSeconds();
      return currentdate;
    },
  },
};
</script>
<style scoped>
.search-form /deep/ .el-form-item__content {
  max-width: 100%;
}
.search-form /deep/ .el-form-item__label {
  min-width: 70px;
  width: 85px;
}
</style>
<style lang="scss" scoped>
.formtable {
  padding: 0 20px;
}

.el-row {
  // margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 5px 0 10px 0;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
// ::v-deep .el-form-item__label {
//   width: 120px;
//   text-align: left;
//   padding: 0;
// }
::v-deep .el-date-editor--datetime {
  width: 100%;
}
.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}
.el-textarea {
  margin: 5px 0;
  width: 100%;
}

.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  // margin: 0px 0 20px 20px;
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}

.formtabs {
  margin: 10px 10px 0 10px;
}
.formtabs-content ::v-deep .el-input-number--small {
  width: 100%;
}
</style>
